export default "__VITE_ASSET__Cfwu2R6p__"